import React, { FC } from 'react';
import { Spinner, Checkbox, Box } from '@chakra-ui/react';

interface BoolCellProps {
  rowId: string;
  value: boolean;
  onChange(id: string, value: boolean): void;
  loading?: boolean;
}

const BoolEditableCell: FC<BoolCellProps> = (props) => {
  const { value, loading } = props;
  return (
    <Box>
      {loading && <Spinner size="sm" />}
      {!loading && (
        <Checkbox
          isChecked={value}
          onChange={(event) =>
            {
              event.stopPropagation();
              props.onChange(props.rowId, event.target.checked);
            }
          }
        />
      )}
    </Box>
  );
};

export default BoolEditableCell;
